export default "__VITE_ASSET__CKOc$RNE__"